import type { ThemeOptions } from '@mui/material'

import { createConfiguratorTheme } from '@salsita-ai/platform-project-sdk/ui'

const themeOptions = {
  components: {
    MuiDialog: {
      styleOverrides: {
        paper: {
          maxWidth: 648,
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: ({ theme: { palette } }) => ({
          color: palette.primary.main,
        }),
      },
    },
    MuiPaper: {
      defaultProps: {
        elevation: 0,
      },
    },
    PhxCardSelectorItem: {
      styleOverrides: {
        header: {
          blockSize: 72,
          padding: 0,
        },
        image: {
          blockSize: 70,
          objectFit: 'cover',
        },
      },
    },
    PhxDeleteEntityButton: {
      defaultProps: {
        muted: true,
      },
    },
    PhxDeleteEntityFab: {
      defaultProps: {
        muted: true,
      },
    },
    PhxDesktopToolbarButton: {
      styleOverrides: {
        button: ({ theme: { palette } }) => ({
          color: palette.primary.main,
        }),
      },
    },
    PhxNumericalInput: {
      defaultProps: {
        variant: 'outlined',
      },
    },
    // PhxPoweredBy: {
    //   defaultProps: {
    //     visible: true,
    //   },
    // },
    PhxPropertyContainerItem: {
      styleOverrides: {
        content: ({ theme: { spacing } }) => ({
          marginBlockStart: spacing(2),
        }),
      },
    },
    PhxSidebarPanel: {
      styleOverrides: {
        padding: {
          padding: 20,
        },
      },
    },
    PhxToggleSelectorRoot: {
      defaultProps: {
        columnCount: 'auto-fit',
      },
    },
    PhxToggleSelectorItem: {
      styleOverrides: {
        button: ({ theme: { spacing } }) => ({
          paddingBlock: spacing(1),
        }),
      },
    },
  },

  // ---------------------------------------------------------------------------
  palette: {
    background: {
      default: '#fff',
      scene: '#fff',
    },

    primary: {
      main: '#0F0F0F',
    },
  },

  // ---------------------------------------------------------------------------
  shape: {
    borderRadius: 0,
  },

  // ---------------------------------------------------------------------------
  typography: {
    fontFamily: '"Luxia", sans-serif',
    fontSize: 16,
    // htmlFontSize: 10,
  },
} satisfies ThemeOptions

export const sunlifeTheme = createConfiguratorTheme(themeOptions)
